export const usertableColumns = [
  {
    id: "S.No",
    label: "S.No",
    minWidth: 70,
    align: "left",
  },
  {
    id: "createdAt",
    label: "Onboarding Date",
    minWidth: 70,
    align: "left",
  },
  {
    id: "fullName",
    label: "Full Name",
    minWidth: 70,
    align: "left",
  },
  {
    id: "email",
    label: "Email",
    minWidth: 70,
    align: "left",
  },
  {
    id: "mobileNumber",
    label: "Phone Number",
    minWidth: 70,
    align: "left",
  },
  {
    id: "isActive",
    label: "Active",
    minWidth: 70,
    align: "center",
  },
  {
    id: "action",
    label: "Action",
    minWidth: 100,
    align: "center",
  },
];
